import styled from 'styled-components'

export const TextContainer = styled.p`
    display: -webkit-box;
    line-height: 14px;
    font-size: 14px;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-family: var(--font-semibold);
    color: #000;
    margin: 0;
`
